export const PERMISSION = {
	ROLE: {
		UPDATE: "update_role",
		CREATE: "create_role",
		VIEW: "list_role",
	},
	CUSTOMER: {
		UPDATE: "update_customer",
		CREATE: "create_customer",
		VIEW: "list_customer",
	},
	MERCHANT: {
		UPDATE: "update_merchant",
		CREATE: "create_merchant",
		VIEW: "list_merchant",
	},
	BANNERS: {
		UPDATE: "update_banner",
		CREATE: "create_banner",
		VIEW: "list_banner",
	},
	STAFF: {
		UPDATE: "update_staff",
		CREATE: "create_staff",
		VIEW: "list_staff",
	},
	POINT: {
		VIEW: "list_point",
	},
	NEWS: {
		UPDATE: "update_news",
		CREATE: "create_news",
		VIEW: "list_news",
	},
	HOTSALE: {
		UPDATE: "update_car_hot_sale",
		VIEW: "list_car_hot_sale",
	},
	APP_VERSION: {
		VIEW: "list_app_version",
		UPDATE: "update_app_version",
	},
	SERVICES: {
		UPDATE: "update_service",
		CREATE: "create_service",
		VIEW: "list_service",
	},
	SERVICE_CATEGORIES: {
		UPDATE: "update_service_category",
		CREATE: "create_service_category",
		VIEW: "list_service_category",
	},
	SUPPORT: {
		UPDATE: "update_support",
		CREATE: "create_support",
		VIEW: "list_support",
	},
	CAMPAIGNS: {
		UPDATE: "update_campaign",
		CREATE: "create_campaign",
		VIEW: "list_campaign",
	},
	CAR_STORE: {
		UPDATE: "update_car_store",
		CREATE: "create_car_store",
		VIEW: "list_car_store",
	},
	SHOWROOM: {
		UPDATE: "update_showroom",
		CREATE: "create_showroom",
		VIEW: "list_showroom",
	},
	DASHBOARD: {
		VIEW: "dashboard",
	},
	CAR: {
		VIEW: "list_car",
		UPDATE: "update_car",
	},
	SUBSCRIPTION: {
		VIEW: "view_subscription",
		UPDATE: "update_subscription",
		CREATE: "create_subscription",
	},
	TRANSACTIONS: {
		VIEW: "list_transaction",
		UPDATE: "update_transaction",
		RECONCILIATION: "reconciliation",
	},
	CONFIG: {
		UPDATE: "update_config",
		CREATE: "create_config",
		VIEW: "list_config",
	},
	ANSWER_SURVEY: {
		VIEW: "list_answer_survey",
	},
	POPUP: {
		CREATE: "create_popup",
		UPDATE: "update_popup",
		VIEW: "list_popup",
	},
	NOTIFICATION_SYSTEM: {
		CREATE: "create_notification_system",
		UPDATE: "update_notification_system",
		VIEW: "list_notification_system",
	},
	CUSTOMER_SUPPORT: {
		UPDATE: "update_customer_support",
		VIEW: "list_customer_support",
	},
	CUSTOMER_REQUEST: {
		VIEW: "list_customer_request",
		UPDATE: "update_customer_request",
	},
	COLLABORATOR: {
		VIEW: "list_collaborator",
		UPDATE: "approve_collaborator",
	},
	AFFILIATE: {
		TRANSACTION: {
			VIEW: "list_affiliate_transaction",
			UPDATE: "update_affiliate_transaction",
		},
	},
	COMMUNITY: {
		VIEW: "list_community",
		UPDATE: "create_community",
	},
	RATING: {
		CREATE: "create_rating",
		LIST: "list_rating",
	},
	LOYALTY: {
		VIEW: "list_loyalty",
		UPDATE: "update_loyalty",
	},
	RECRUITMENT: {
		VIEW: "list_recruitment",
		UPDATE: "update_recruitment",
	},
	AUCTION: {
		UPDATE: "update_auction_section",
		VIEW: "list_auction_section",
	},
	BILLING_INFORMATION: {
		VIEW: "view_billing_information",
		UPDATE: "update_billing_information",
		CHANGE_MERCHANT_SUBSCRIPTION: "change_merchant_subscription",
	},
	INVESTMENT: {
		LIST: "list_investment",
		EDIT: "edit_investment",
	},
};
